import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

interface CurrentEmployeeHeaderProps {
    currentEmployee: EmployeeUIModel;
    currentSpecialtyId: string;
    onToggleSpecialization: (specialtyId: string) => void;
}

export class CurrentEmployeeHeader extends BaseReactComponent<CurrentEmployeeHeaderProps> {
    public render(): JSX.Element {
        const specs = this.props.currentEmployee.getServiceSpecializations();
        return (
            <div>
                <p>
                    {this.props.currentEmployee.nameWithPrefix() + " "}
                    {specs?.any() && (
                        <span>
                            (
                            <a
                                onClick={() => {
                                    const currentIndex = specs.findIndex(p => p.LookupID === this.props.currentSpecialtyId);
                                    this.props.onToggleSpecialization(specs[(currentIndex + 1) % specs.length].LookupID);
                                }}
                            >
                                {specs
                                    .firstOrDefault(p => p.LookupID === this.props.currentSpecialtyId)
                                    .GetValue()
                                }
                            </a>
                            )
                        </span>
                    )}
                </p>
                <p>{LuxonDateTimeParser.parse(new Date()).toFormat("yyyy/LL/dd")}</p>
            </div>
        );
    }
}
